import { jsx as r } from "react/jsx-runtime";
import w from "react";
import { clsx as b } from "../../../utils/clsx.js";
import { FlexRestricter as R } from "./FlexRestricter.js";
import '../../../assets/Flex.css';const F = "_root_1audv_1", z = "_centered_1audv_11", C = "_vertical_1audv_30", N = "_repell_1audv_36", E = "_wrap_1audv_39", T = "_stretch_1audv_51", j = "_horizontal_1audv_57", e = {
  root: F,
  "full-width": "_full-width_1audv_5",
  "full-height": "_full-height_1audv_8",
  centered: z,
  "centered-axis": "_centered-axis_1audv_15",
  "centered-cross-axis": "_centered-cross-axis_1audv_18",
  "baseline-axis": "_baseline-axis_1audv_21",
  "baseline-cross-axis": "_baseline-cross-axis_1audv_24",
  "reverse-order": "_reverse-order_1audv_27",
  vertical: C,
  repell: N,
  wrap: E,
  "align-to-end": "_align-to-end_1audv_42",
  "align-to-end-axis": "_align-to-end-axis_1audv_45",
  "space-between": "_space-between_1audv_48",
  stretch: T,
  horizontal: j,
  "gap-none": "_gap-none_1audv_63",
  "gap-thin": "_gap-thin_1audv_66",
  "gap-xsmall": "_gap-xsmall_1audv_69",
  "gap-small": "_gap-small_1audv_72",
  "gap-normal": "_gap-normal_1audv_75",
  "gap-large": "_gap-large_1audv_78",
  "gap-xlarge": "_gap-xlarge_1audv_81"
};
function A(l, s) {
  const {
    fullWidth: _ = !1,
    fullHeight: o = !1,
    vertical: t = !1,
    centered: a = !1,
    repell: i = !1,
    stretch: d = !1,
    wrap: c = !1,
    alignToEnd: u = !1,
    alignToEndAxis: p = !1,
    spaceBetween: v = !1,
    reverseOrder: g = !1,
    gap: x = "normal",
    children: f,
    className: h
  } = l, m = b(e.root, h, e[`gap-${x}`], {
    [e["full-width"]]: _,
    [e["full-height"]]: o,
    [e.centered]: a === !0,
    [e["centered-axis"]]: a === "axis",
    [e["centered-cross-axis"]]: a === "cross-axis",
    [e["baseline-axis"]]: a === "baseline-axis",
    [e["baseline-cross-axis"]]: a === "baseline-cross-axis",
    [e.vertical]: t,
    [e.horizontal]: !t,
    [e.repell]: i,
    [e.stretch]: d,
    [e.wrap]: c,
    [e["align-to-end"]]: u,
    [e["align-to-end-axis"]]: p,
    [e["space-between"]]: v,
    [e["reverse-order"]]: g
  });
  return /* @__PURE__ */ r("div", { ref: s, className: m, children: f });
}
const B = w.forwardRef(A), n = B;
n.Restricted = function({
  children: s
}) {
  return /* @__PURE__ */ r(n, { children: /* @__PURE__ */ r(R, { children: s }) });
};
export {
  n as Flex
};
